import makeApiCall from "./master/axiosIndex";

export const buyerApis = {
  fetchRolesDropDown: () =>
    makeApiCall({
      url: `/buyer/fetchRoleDropdown`,
      method: "get",
    }),
  fetchUsersDropDown: (roleId: number) =>
    makeApiCall({
      url: `/buyer/fetchAppUsersByRoleId?id=${roleId}`,
      method: "get",
    }),
  fetchGroupByMaterials: (params: {
    projectIds: string;
    phaseIds: string | string[];
    activityIds: string | string[];
    startDate: string;
    endDate: string;
    taskStatus: string[];
    showOnlyShortageMaterials?: string;
    contractorIds?: string | number;
  }): Promise<any> => {
    // Build query string manually to handle repeated taskStatus parameters
    const searchParams = new URLSearchParams();

    searchParams.append("projectIds", params.projectIds);

    // Handle phaseIds - join array with commas if it's an array
    if (Array.isArray(params.phaseIds)) {
      searchParams.append("phaseIds", params.phaseIds.join(","));
    } else {
      searchParams.append("phaseIds", params.phaseIds);
    }

    // Handle activityIds - join array with commas if it's an array
    if (Array.isArray(params.activityIds)) {
      searchParams.append("activityIds", params.activityIds.join(","));
    } else {
      searchParams.append("activityIds", params.activityIds);
    }

    searchParams.append("startDate", params.startDate);
    searchParams.append("endDate", params.endDate);

    // Add each taskStatus as a separate parameter (repeated parameters)
    if (params.taskStatus && Array.isArray(params.taskStatus)) {
      params.taskStatus.forEach((status: string) => {
        searchParams.append("taskStatus", status);
      });
    }

    if (params.showOnlyShortageMaterials) {
      searchParams.append(
        "showOnlyShortageMaterials",
        params.showOnlyShortageMaterials
      );
    }

    if (
      params.contractorIds !== undefined &&
      params.contractorIds !== null &&
      params.contractorIds !== ""
    ) {
      searchParams.append("contractorIds", params.contractorIds.toString());
    }

    const url = `/task/groupByMaterials?${searchParams.toString()}`;

    return makeApiCall({
      url,
      method: "get",
    });
  },
  fetchSiteUsers: async (siteId: string | number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchSiteUsers?siteId=${siteId}`,
      method: "get",
    });
  },
  fetchAddressBySiteId: async (siteId: string | number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchAddressBySiteId?id=${siteId}`,
      method: "get",
    });
  },
  createPurhcaseRequest: (data: any): Promise<any> => {
    return makeApiCall({
      url: "/purchase-request/new",
      method: "post",
      data,
    });
  },
  fetchSequence: (): Promise<any> => {
    return makeApiCall({
      url: "/buyer/fetchSequence",
      method: "get",
    });
  },
  fetchSegmentLevelBySiteId: (siteId: string | number): Promise<any> => {
    return makeApiCall({
      url: `/buyer/fetchSegmentLevelBySiteId?siteId=${siteId}`,
      method: "get",
    });
  },
};
